import { useEffect, useRef, useState } from "react";
import Chart from "chart.js/auto";
import { Link } from 'react-router-dom'
import $ from "jquery";
import jszip from "jszip";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import Lineicons from "@lineiconshq/react-lineicons";
import { EyeStroke } from "@lineiconshq/free-icons";
import HomeCharts from '../components/HomeCharts';

pdfMake.vfs = pdfFonts.vfs;
const Home = () => {

     const tableRef = useRef(null);

  // --- State for Modals and Referee Assignment ---
  const [showGameModal, setShowGameModal] = useState(false);
  const [showAssignList, setShowAssignList] = useState(false);
  const [assignedReferee, setAssignedReferee] = useState("Unassigned");

  // --- Initialize DataTable ---
  useEffect(() => {
    window.JSZip = jszip;
    const table = $(tableRef.current).DataTable({
      responsive: true,
      pageLength: 5,
      lengthChange: false,
      ordering: true,
      destroy: true,
      dom:
        "<'row mb-3'<'col-sm-12 col-md-12'f>>" +
        "<'row'<'col-sm-12'tr>>" +
        "<'row mt-3'<'col-sm-12 col-md-12'i><'col-sm-12 col-md-12'B p>>",
      buttons: [
        { extend: "copy", text: "Copy" },
        { extend: "excel", text: "Excel" },
        { extend: "pdf", text: "PDF" },
        { extend: "print", text: "Print" },
      ],
    });
    return () => table.destroy();
  }, []);

  // --- Handlers ---
  const openGameDetail = () => setShowGameModal(true);
  const closeGameDetail = () => {
    setShowGameModal(false);
    setShowAssignList(false);
  };

  const toggleAssignList = () => setShowAssignList(!showAssignList);

  const assignReferee = (name) => {
    setAssignedReferee(name);
    setShowAssignList(false);
    setShowGameModal(true);
    alert(`Referee ${name} assigned. Offer sent to mobile app.`);
  };

    return (
        <>
            <div className="page-wrapper">
                <div className="page-content">
                    <div className="dashTabs">
                        <ul className="nav nav-tabs d-flex align-items-center" id="summaryTabs" role="tablist">
                            {/* Affiliated Clubs */}
                            <li className="nav-item" role="presentation">
                                <button className="nav-link active" id="clubs-tab" data-bs-toggle="tab" data-bs-target="#clubs-graph" type="button" role="tab">
                                    <div className="card radius-10 mb-0">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center card_box">
                                                <div className="me-auto">
                                                    <p className="mb-0 text-white">Affiliated Clubs</p>
                                                    <h4 className="my-1 text-white">120</h4>
                                                    <p className="mb-0 font-13 text-white">Registered Clubs</p>
                                                </div>
                                                <div>
                                                    <img src="images/main-page/total-mama.png" alt="Clubs" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </button>
                            </li>
                            {/* Hired Referees */}
                            <li className="nav-item" role="presentation">
                                <button className="nav-link" id="referees-tab-btn" data-bs-toggle="tab" data-bs-target="#referees-graph" type="button" role="tab">
                                    <div className="card radius-10 mb-0">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center card_box">
                                                <div className="me-auto">
                                                    <p className="mb-0 text-white">Hired Referees</p>
                                                    <h4 className="my-1 text-white">350</h4>
                                                    <p className="mb-0 font-13 text-white">Referees on duty</p>
                                                </div>
                                                <div>
                                                    <img src="images/main-page/total-mama.png" alt="Referees" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </button>
                            </li>
                            {/* Scheduled Games */}
                            <li className="nav-item" role="presentation">
                                <button className="nav-link" id="scheduled-tab" data-bs-toggle="tab" data-bs-target="#scheduled-graph" type="button" role="tab">
                                    <div className="card radius-10 mb-0 black-card">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center card_box">
                                                <div className="me-auto">
                                                    <p className="mb-0 text-white">Scheduled Games</p>
                                                    <h4 className="my-1 text-white">45</h4>
                                                    <p className="mb-0 font-13 text-white">Upcoming matches</p>
                                                </div>
                                                <div>
                                                    <img src="images/main-page/suitcase.png" alt="Games" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </button>
                            </li>
                            {/* Support Tickets */}
                            <li className="nav-item" role="presentation">
                                <button className="nav-link" id="support-tab" data-bs-toggle="tab" data-bs-target="#support-graph" type="button" role="tab">
                                    <div className="card radius-10 mb-0 black-card">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center card_box">
                                                <div className="me-auto">
                                                    <p className="mb-0 text-white">Support Tickets</p>
                                                    <h4 className="my-1 text-white">10</h4>
                                                    <p className="mb-0 font-13 text-white">Open tickets</p>
                                                </div>
                                                <div>
                                                    <img src="images/main-page/suitcase.png" alt="Support" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </button>
                            </li>
                        </ul>
                    </div>
                    <div className="row g-4">
                        {/* ================= Games Summary ================= */}
                        <div className="col-12 col-lg-6">
                            <div className="card radius-10 h-100 summry_box">
                                {/* Header */}
                                <div className="card-header d-flex flex-wrap align-items-center">
                                    <h6 className="mb-0">Games Summary</h6>
                                    {/* Filters Right Side */}
                                    <div className="ms-auto d-flex gap-2 mt-2 mt-lg-0">
                                        <select className="form-select form-select-sm w-auto">
                                            <option>Season 2026</option>
                                            <option>Season 2025</option>
                                        </select>
                                        <select className="form-select form-select-sm w-auto">
                                            <option>All Age Groups</option>
                                            <option>U12</option>
                                            <option>U15</option>
                                            <option>U18</option>
                                        </select>
                                    </div>
                                </div>
                                <ul>
                                    <li style={{ background: 'rgb(1 230 151 / 11%)' }}>Requested <span style={{ color: 'rgba(13, 110, 253, 0.95)' }}>15</span></li>
                                    <li style={{ background: 'rgba(253, 126, 20, 0.12)' }}>Upcoming <span style={{ color: 'rgb(253, 126, 20)' }}>14</span></li>
                                    <li style={{ background: 'rgba(25, 135, 84, 0.13)' }}>Live <span style={{ color: 'rgb(25, 135, 84)' }}>5</span></li>
                                    <li style={{ background: 'rgba(220, 53, 69, 0.25)' }}>Completed <span style={{ color: 'rgb(220, 53, 69)' }}>120</span></li>
                                    <li style={{ background: 'rgba(13, 110, 253, 0.13)' }}>Cancelled <span style={{ color: 'rgba(13, 110, 253, 0.95)' }}>3</span></li>
                                </ul>
                            </div>
                        </div>
                        {/* ================= Referees Summary ================= */}
                        <div className="col-12 col-lg-6">
                            <div className="card radius-10 h-100 summry_box">
                                {/* Header */}
                                <div className="card-header">
                                    <h6 className="mb-0">Referees Summary</h6>
                                </div>
                                <ul>
                                    <li style={{ background: 'rgba(13, 110, 253, 0.13)' }}>
                                        <div><i className="bx bx-user-check" title="User Check" style={{ color: 'rgba(13, 110, 253, 0.95)' }} /> Hired</div><span style={{ color: 'rgba(13, 110, 253, 0.95)' }}>156</span>
                                    </li>
                                    <li style={{ background: 'rgba(111, 66, 193, 0.16)' }}>
                                        <div><i className="bx bx-group" title="Children" style={{ color: 'rgb(111, 66, 193)' }} />
                                            Child Referees</div><span style={{ color: 'rgb(111, 66, 193)' }}>89</span>
                                    </li>
                                    <li style={{ background: 'rgba(25, 135, 84, 0.13)' }}>
                                        <div><i className="bx bx-check-circle" title="Available" style={{ color: 'rgb(25, 135, 84)' }} /> Applications</div><span style={{ color: 'rgb(25, 135, 84)' }}>67</span>
                                    </li>
                                    <li style={{ background: 'rgba(73, 80, 87, 0.23)' }}>
                                        <div><i className="bx bx-check-circle" title="Available" style={{ color: 'rgb(73, 80, 87)' }} /> Invitation sent</div><span style={{ color: 'rgb(73, 80, 87)' }}>44</span>
                                    </li>
                                    <li style={{ background: 'rgba(13, 110, 253, 0.13)' }}>
                                        <div><i className="bx bx-user-check" title="User Check" style={{ color: 'rgba(13, 110, 253, 0.95)' }} /> Declined</div><span style={{ color: 'rgba(13, 110, 253, 0.95)' }}>10</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="tab-content" id="summaryTabsContent">

                                <div className="tab-pane fade show active" id="clubs-graph" role="tabpanel">
                                    <div className="card radius-10">
                                        <div className="card-body">
                                            <h6 className="mb-3">Affiliated Clubs Over Time</h6>
                                            <div className="chart-container-0">
                                                <HomeCharts
                                                    label="Affiliated Clubs"
                                                    color="#01e697"
                                                    data={[10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65]}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="tab-pane fade" id="referees-graph" role="tabpanel">
                                    <div className="card radius-10">
                                        <div className="card-body">
                                            <h6 className="mb-3">Hired Referees Over Time</h6>
                                            <div className="chart-container-0">
                                                <HomeCharts
                                                    label="Hired Referees"
                                                    color="#01e697"
                                                    data={[20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130]}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="tab-pane fade" id="scheduled-graph" role="tabpanel">
                                    <div className="card radius-10">
                                        <div className="card-body">
                                            <h6 className="mb-3">Scheduled Games Over Time</h6>
                                            <div className="chart-container-0">
                                                <HomeCharts
                                                    label="Scheduled Games"
                                                    color="#01e697"
                                                    data={[5, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48]}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="tab-pane fade" id="support-graph" role="tabpanel">
                                    <div className="card radius-10">
                                        <div className="card-body">
                                            <h6 className="mb-3">Support Tickets Over Time</h6>
                                            <div className="chart-container-0">
                                                <HomeCharts
                                                    label="Support Tickets"
                                                    color="#01e697"
                                                    data={[2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24]}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>{/*end row*/}
                    <div className="row">
                        <div className="col-12">
                            <div className="card radius-10 mt-3">
                                <div className="card-header">
                                    <div className="d-flex align-items-center">
                                        <div>
                                            <h6 className="mb-0">Recent Games</h6>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="entries-wrapper mb-3 home-entress">
                                        <label className="entries-label">
                                            <span>Showing</span>
                                            <select className="entries-select">
                                                <option value={10} selected>10</option>
                                                <option value={25}>25</option>
                                                <option value={50}>50</option>
                                                <option value={100}>100</option>
                                            </select>
                                            <span>Entries</span>
                                        </label>
                                    </div>
                                    <div className="table-responsive">
                                        <table
                                            id="referee_list"
                                            ref={tableRef}
                                            className="table table-striped table-bordered"
                                        >
                                            <thead>
                                                <tr>
                                                    <th>Venue</th>
                                                    <th>Age Group</th>
                                                    <th>Home Team</th>
                                                    <th>Away Team</th>
                                                    <th>Referee</th>
                                                    <th>Season</th>
                                                    <th>Date &amp; Time</th>
                                                    <th>Status</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>City Stadium</td>
                                                    <td>U15</td>
                                                    <td>Blue Lions <small className="text-muted">(City Club)</small></td>
                                                    <td>Red Tigers <small className="text-muted">(Downtown Club)</small></td>
                                                    <td>John Clark</td>
                                                    <td>Winter 2026</td>
                                                    <td>27 Feb 2026, 10:00 AM</td>
                                                    <td><span className="badge bg-light-success text-success w-100">Completed</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center gap-2">
                                                            <li><a onClick={openGameDetail}><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>National Ground</td>
                                                    <td>U17</td>
                                                    <td>Green Warriors <small className="text-muted">(National Club)</small></td>
                                                    <td>Yellow Falcons <small className="text-muted">(Eastside Club)</small></td>
                                                    <td>David Smith</td>
                                                    <td>Spring 2026</td>
                                                    <td>01 Mar 2026, 02:00 PM</td>
                                                    <td><span className="badge bg-light-warning text-warning w-100">Pending</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center gap-2">
                                                            <li><a onClick={openGameDetail}><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                {/* Referee 3 */}
                                                <tr>
                                                    <td>Sports Complex</td>
                                                    <td>U19</td>
                                                    <td>Silver Hawks <small className="text-muted">(Silver Club)</small></td>
                                                    <td>Black Panthers <small className="text-muted">(Panther Club)</small></td>
                                                    <td>Michael Brown</td>
                                                    <td>Spring 2026</td>
                                                    <td>05 Mar 2026, 04:30 PM</td>
                                                    <td><span className="badge bg-light-danger text-danger w-100">Cancelled</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center gap-2">
                                                            <li><a onClick={openGameDetail}><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                {/* Referee 4 */}
                                                <tr>
                                                    <td>Central Arena</td>
                                                    <td>U13</td>
                                                    <td>Orange Stars <small className="text-muted">(Central Club)</small></td>
                                                    <td>White Sharks <small className="text-muted">(White Club)</small></td>
                                                    <td>Chris Johnson</td>
                                                    <td>Spring 2026</td>
                                                    <td>10 Mar 2026, 09:00 AM</td>
                                                    <td><span className="badge bg-light-info text-info w-100">Upcoming</span></td>
                                                    <td>
                                                        <ul className="tbl_actions_wrap d-flex align-items-center gap-2">
                                                            <li><a onClick={openGameDetail}><i className="lni lni-eye" data-bs-toggle="tooltip" title="View" /></a></li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>{/*end row*/}
                </div>
            </div>







                <div className="modal fade" id="delete_modal" tabIndex={-1} aria-labelledby="deleteModalLabel" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="deleteModalLabel">Confirmation Alert!</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                            </div>
                            <div className="modal-body">
                                <h5>Are you sure you want to delete this ticket?</h5>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger">Yes, Delete</button>
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
                {showGameModal && (
               <div className="modal show d-block game-modal" tabIndex={-1}>
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title fw-bold">Game #GM-002</h5>
                                <button type="button" className="btn-close" onClick={closeGameDetail} />
                            </div>
                            <div className="modal-body p-4">
                                {/* Game general info grid */}
                                <div className="mb-4">
                                    <div className="row mb-3">
                                        <div className="col-6">
                                            <label className="text-secondary">Game ID</label>
                                            <h5>#GM-002</h5>
                                        </div>
                                        <div className="col-6">
                                            <label className="text-secondary">Status</label>
                                            <span className="badge bg-primary bg-opacity-10 text-primary rounded-pill px-3 py-2">
                                                ● Upcoming
                                            </span>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-6">
                                            <label className="text-secondary">Home Team</label>
                                            <h5>Stars U12 / North Stars SC</h5>
                                        </div>
                                        <div className="col-6">
                                            <label className="text-secondary">Away Team</label>
                                            <h5>Bears U12 / Eagle Sports</h5>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-6">
                                            <label className="text-secondary">Age Group</label>
                                            <h5>U-12</h5>
                                        </div>
                                        <div className="col-6">
                                            <label className="text-secondary">Season</label>
                                            <h5>Spring 2026 (Jan 1 – Mar 22, 2026)</h5>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-6">
                                            <label className="text-secondary">Venue</label>
                                            <h5>North Ground</h5>
                                        </div>
                                        <div className="col-6">
                                            <label className="text-secondary">Date &amp; Time</label>
                                            <h5>Mar 2, 2:00 PM</h5>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-6">
                                            <label className="text-secondary">Referee</label>
                                            <h5>{assignedReferee}</h5>
                                        </div>
                                        <div className="col-6">
                                            <label className="text-secondary">Referee Payout</label>
                                            <h5>$150</h5>
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-5 mb-5">
                                    <h5>Referee Assignment</h5>
                                    <button id="showRefListBtn" onClick={toggleAssignList} className="btn btn-primary">Assign Referee</button>
                                
                                 {showAssignList && (
                                     <div className="mt-3">
                                        <p className="mb-2">Eligible referees (Spring 2026, U-12, no conflict Mar 2 2:00PM)</p>
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th>Age groups</th>
                                                    <th>Status</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Mark Johnson</td>
                                                    <td>U-10, U-12</td>
                                                    <td>Available</td>
                                                    <td><button className="btn btn-sm btn-primary" onclick="assignRef('Mark Johnson')">Assign</button></td>
                                                </tr>
                                                <tr>
                                                    <td>Lisa Ray</td>
                                                    <td>U-12, U-15</td>
                                                    <td>Available</td>
                                                    <td><button className="btn btn-sm btn-primary" onclick="assignRef('Lisa Ray')">Assign</button></td>
                                                </tr>
                                                <tr>
                                                    <td>Tom Harris</td>
                                                    <td>U-12</td>
                                                    <td>Available</td>
                                                    <td><button className="btn btn-sm btn-primary" onclick="assignRef('Tom Harris')">Assign</button></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <button id="backRefListBtn" className="btn btn-secondary mt-2" onClick={toggleAssignList}>Back</button>
                                    </div>
                                     )}

                                </div>
                                <div className="row mb-3">
                                    <div className="col-12">
                                        <h6 className="fw-bold mb-0">TEAM ROSTERS</h6>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="fw-bold mb-3">Stars U12</div>
                                        <div className="d-flex flex-column gap-2">
                                            <div>#7 Jake Smith</div>
                                            <div>#9 Tyler Brown</div>
                                            <div>#11 Ryan Davis</div>
                                            <div>#3 Oliver Lee</div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="fw-bold mb-3">Bears U12</div>
                                        <div className="d-flex flex-column gap-2">
                                            <div>#4 Max Turner</div>
                                            <div>#8 Alex Kim</div>
                                            <div>#10 Sam Reed</div>
                                            <div>#6 Chris Perk</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Team Rosters */}
                        </div>
                    </div>
                </div>  
)}
        </>
    )
}

export default Home